module.exports = __webpack_public_path__ + "assets/img/usdt_qrcode.9ac41fbc.jpg";